import 'airbnb-js-shims'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'core-js/stable'
import 'mdb-react-ui-kit/dist/css/mdb.min.css'
import React from 'react'
import { Cookies, CookiesProvider } from 'react-cookie-banner'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import 'regenerator-runtime/runtime'
import App from './App'
import './index.css'
import { unregister } from './registerServiceWorker';
import store from './store'
import { LoadingProvider } from './context/LoadingContext/LoadingContext';
import LoadingOverlay from './components/LoadingOverlay/LoadingOverlay';
import TagManager from 'react-gtm-module';

const cookies = new Cookies(document.cookie)

const rootComponent = (
    <Provider store={store}>
        <CookiesProvider cookies={cookies}>
            <Router>
                <LoadingProvider>
                    <App />
                    <LoadingOverlay />
                </LoadingProvider>
            </Router>
        </CookiesProvider>
    </Provider>
)

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)
root.render(rootComponent)

unregister()
